<!DOCTYPE html>
<html lang="en">
<meta http-equiv="content-type" content="text/html;charset=utf-8" />
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Food Safety On Wheels</title>
 <script src="/assets/js/jquery.min.js"></script>

	<link rel="stylesheet" href="/assets/css/bootstrap.css" />
    <link rel="stylesheet" href="/assets/css/style.css" />
    <link rel="stylesheet" href="/assets/css/responsive.css" />
	<!-- <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;0,600;0,700;0,800;1,800&display=swap" rel="stylesheet">
   -->

</head>

<body>

<section class="top-menu">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <nav class="navbar navbar-expand-md bg-dark navbar-dark">
                  <a class="navbar-brand" href="#"><img src="/assets/img/logo.png" style="width:210px; margin-left: -50px;"></a>
                    <img src="/assets/img/fsw_header1.png" style="width:400px; margin-left: 150px;">
                  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span class="navbar-toggler-icon"></span>
                  </button>
                  <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                    <ul class="navbar-nav">
                      <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/home']" style="margin-left: 50px;">Home</a>
                      </li>
                      <!-- <li class="nav-item">
                        <a class="nav-link" href="about-us.html">About Us</a>
                      </li> -->
                      <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/contact']" style="margin-left: 10px;">Contact</a>
                      </li>
                      <li class="nav-item">
           <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal">Login</button> -->
          
           <!-- <button type="button" class="btn btn-primary" routerLink="/login">Login</button> -->
        </li>
                    </ul>
                  </div>
                </nav>
            </div>
        </div>
    </div>
</section>
<div class="container-fluid" style="padding-top:80px;">
<div class="card card-outline card-primary" style="width:450px;top:0;bottom:0;left:0;right:0;margin:auto;">
    <div class="card-header text-center">
        <!-- <a [routerLink]="['/']" class="h1"><b>Admin</b>LTE</a> -->
        <a [routerLink]="['/']" class="h1"><b>Food Safety On Wheels</b></a>
    </div>
    <div class="card-body">
        <p class="login-box-msg">Sign in</p>

        <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()">
            <div class="input-group mb-3">
                <input
                    formControlName="userId"
                    type="email"
                    class="form-control"
                    placeholder="User Id"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-envelope"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-lock"></span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-7">
                    <!-- <div class="icheck-primary">
                        <input type="checkbox" id="remember" />
                        <label for="remember"> Remember Me </label>
                    </div> -->
                </div>
                <!-- /.col -->
                <div class="col-5">
                    <app-button
                        [type]="'submit'"
                        [block]="true"
                        [loading]="isAuthLoading"
                        [disabled]="isFacebookLoading || isGoogleLoading"
                    >
                        Sign In
                    </app-button>
                </div>
                <!-- /.col -->
            </div>
        </form>

        <!-- <div class="social-auth-links text-center mb-3">
            <app-button
                class="mb-2"
                [block]="true"
                [loading]="isFacebookLoading"
                [disabled]="isAuthLoading || isGoogleLoading"
                [icon]="'facebook'"
                (click)="loginByFacebook()"
            >
                Sign in using Facebook
            </app-button>
            <app-button
                [block]="true"
                [loading]="isGoogleLoading"
                [disabled]="isAuthLoading || isFacebookLoading"
                [icon]="'google'"
                [color]="'danger'"
                (click)="loginByGoogle()"
            >
                Sign in using Google+
            </app-button>
        </div> -->

        <!-- <p class="mb-1">
            <a [routerLink]="['/forgot-password']">I forgot my password</a>
        </p> -->
        <!-- <p class="mb-0">
            <a [routerLink]="['/register']" class="text-center">
                Register a new membership
            </a>
        </p> -->
    </div>
    <!-- /.login-card-body -->
</div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>

</body>
